/*******************************************************************************
 *
 * This file is part of the LGS1920/studio project.
 *
 * File: theJourneyEditor.js
 *
 * Author : LGS1920 Team
 * email: studio@lgs1920.fr
 *
 * Created on: 2026-01-06
 * Last modified: 2026-01-06
 *
 *
 * Copyright © 2026 LGS1920
 ******************************************************************************/

export const theJourneyEditor = {
    journey: null,
    track: null,
    poi: null,
    flags: {
        start: null,
        stop: null,
    },
    allPOIs: true,
    longTask: false,
    showPOIsFilter: false,
    tab: false,
}